/**
 * useProfilesState — Local state for the profiles management UI.
 */
import { useState } from 'react';

interface Profile {
  id: string;
  display_name?: string;
  email?: string;
}

export function useProfilesState() {
  const [profiles, setProfiles] = useState<Record<string, Profile>>({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [fetchedIds, setFetchedIds] = useState<Set<string>>(new Set());
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  return {
    profiles,
    setProfiles,
    loading,
    setLoading,
    error,
    setError,
    fetchedIds,
    setFetchedIds,
    refreshTrigger,
    setRefreshTrigger
  };
}

export type ProfilesState = ReturnType<typeof useProfilesState>;
